module.exports = __webpack_public_path__ + "static/media/SarahSwitek_14_ActivitiesConclusion_2.3dbeac85.mp3";